import script from "./SecretCodeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SecretCodeModal.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/pc/received.css?vue&type=style&index=0&id=e925d55c&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e925d55c"]])

export default __exports__